module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/message-alert/message-alert-style5/message-alert-style5.component.scss
// module id = ./src/app/features/message-alert/message-alert-style5/message-alert-style5.component.scss
// module chunks = main